
const myOrderList = () => {
    const $document = $(document);

    const lowsMchoiceListCount = () => {
        $document
            .on('click', '.mchoice__list .btn__count-down', function() {
                const $this = $(this);
                const $target = $this.siblings('input');
                const _max_count = Number($target.attr('data-max-count'));

                menuAmount( $this, $target, _max_count );
            })
       
            .on('click', '.mchoice__list .btn__count-up', function() {
                const $this = $(this);
                const $target = $this.siblings('input');
                const _max_count = Number($target.attr('data-max-count'));
    
                menuAmount( $this, $target, _max_count );
            })
            .on('keyup', '.mchoice__list__count input', function( e ) {
                const $this = $(this);
                const _val = $this.val();
                const _max_count = Number($this.attr('data-max-count'));

                if ( _val === '0' ) {
                    $this.siblings('.btn__count-down').attr('disabled', true);
                    $this.removeClass('on').closest('.mchoice__list__count').siblings('input[type="checkbox"]').prop('checked', false);
                } else if ( _val > _max_count ) {
                    alert('최대수량입니다.');
                    return $this.val(_max_count);
                }
            });

            const menuAmount = ( $button, $input, _maxCount ) => {
                let _val = Number($input.val());

                if ( $button.hasClass('btn__count-down') ) {
                    if ( 1 < _val ) {
                        _val -= 1;
                    } else {
                        $button.attr('disabled', true);
                        $input.removeClass('on').closest('.mchoice__list__count').siblings('input[type="checkbox"]').prop('checked', false);
                        _val = 0;
                    }
                } else {
                    if ( _val < _maxCount ) {
                        $button.siblings('.btn__count-down').attr('disabled', false);
                        $input.addClass('on').closest('.mchoice__list__count').siblings('input[type="checkbox"]').prop('checked', true);
                        _val += 1;
                    } else {
                        alert('최대수량입니다.');
                        _val = _maxCount;
                    }
                }

                $input.val(_val);
            };
    };

    // 주문배송결제(정기배송) 이중팝업 이벤트처리
    const overlayPopup = () => {
        const $firstPop = $('.first-pop')
        const $firstPopBtn = $firstPop.find('.btn-next');

        $firstPopBtn
            .on('click', function() {
                $firstPop.closest('.hd__popup').removeClass('popup__modal-open');
            })
    };

    // 첨부파일 미리보기
    const filePreview = function filePreview() {
        const $inputFile = $('.image-box input[type=file]');
        const $btn_del = $('.del'); 
        
            $inputFile
                .on('change', function(e) {
                    const $this = $(this);
                    const $targetImg = $this.next('figure').find('img');
                    const _thisData = Number($this.data('maxmemory-mb'));
                    const _maxSize = ( _thisData * 1024 * 1024 ); // maxSize 1MB 이상
                    const files = $this[0].files;
                    let _fileSize = 0;
                    let reader;
                    
                    if ( files && files[0] ) {
                        
                        reader = new FileReader();
                        
                        _fileSize = files[0].size;
                        
                        if ( _fileSize >= _maxSize ) {
                            $this.val('');
                            alert("30MB 미만의 파일만 등록 가능합니다.");
                        } else {
                            $this.siblings('.del').show();
                            
                            reader.onload = function (e) {
                                $targetImg.attr('src', e.target.result);
                            };
                        }				        

                        reader.readAsDataURL(files[0]);
                    } else {
                        $this.val('');
                        $targetImg.attr('src', '/front_mo/images/img_comm_preview.png');
                    }
                });
            
            $btn_del
                .on('click', function() {
                    const $this = $(this);
                    
                    $this.hide();
                    $this.siblings('input[type="file"]').val('');
                    $this.siblings('figure').find('img').attr('src', '/front_mo/images/img_comm_preview.png');
                    
                });
    };

    filePreview();

    const myOrderList_init = () => {
        lowsMchoiceListCount();
        overlayPopup();
        filePreview();
    };

    myOrderList_init();
}

export default myOrderList;